"use strict";

angular.module("customer")
.directive("quantityField", function() {
    return {
        restrict: "E",
        controllerAs: "quantityFieldCtrl",
        templateUrl: require("./quantity-field.directive.html"),
        scope: true,
        bindToController: {
            quantity: "=",
            saveQuantity: "&",
            packagingQuantity: "<",
            suggestedOrderMultiplier: "<?",
            externalFocus: "<?",
            removeOrderMultiplierMention: "<?",
            useVariableMeasure: "<?"
        },
        controller: function($scope, gettextCatalog) {
            var _this = this;
            var currentQuantity = this.quantity;

            $scope.$on("LanguageChanged", function() {
                refreshOrderMultiplierLanguage();
            });

            $scope.orderMultiplierTooltipPlacement = 'bottom-right';
            this.$onInit = function() {
                if (this.useVariableMeasure) {
                    $scope.orderMultiplierTooltipPlacement = 'bottom-left';
                }
                refreshOrderMultiplierLanguage();
            };

            function refreshOrderMultiplierLanguage() {
                $scope.orderMultiplierText = gettextCatalog.getString("Suggested Order Multiplier {{suggestedOrderMultiplier}}", {
                    suggestedOrderMultiplier: _this.suggestedOrderMultiplier
                });
            }

            this.enableOrderMultiplierTooltip = function() {
                return !this.removeOrderMultiplierMention && this.suggestedOrderMultiplier && (this.focus || this.externalFocus);
            };

            this.copyCurrentQuantity = function() {
                currentQuantity = this.quantity;
            };

            this.saveNewQuantity = function() {
                if (currentQuantity !== this.quantity) {
                    this.saveQuantity({quantity: this.quantity});
                    currentQuantity = this.quantity;
                }
            };

            this.autoSelect = function($event) {
                $event.stopPropagation();
                return $event.target.select();
            };

            this.onFocus = function($event) {
                $event.stopPropagation();
                this.focus = true;
                this.copyCurrentQuantity();
            };

            this.onBlur = function() {
                this.focus = false;
                this.saveNewQuantity();
            };
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/quantity-field/quantity-field.directive.js
// module id = 793
// module chunks = 0